<div id="component-container" class="form-group" [style.width]="width">
	<label *ngIf="ariaLabel || placeHolderText" [attr.for]="inputId" class="screenreader-only">{{ ariaLabel || placeHolderText }}</label>
	<input type="text" class="b-inputtext" id="{{inputId}}" name="{{ fieldName }}" placeholder="{{ placeHolderText }}"
		[required]="required" #textInputRef (input)="onTextInput($event)"
		[attr.role]="comboboxMode ? 'combobox' : (isSearchField ? 'searchbox' : null)"
		[attr.aria-controls]="ariaControls"
		[attr.aria-activedescendant]="ariaActiveDescendant"
		[attr.aria-expanded]="comboboxMode ? 'true' : null"
		[attr.aria-autocomplete]="comboboxMode ? 'list' : null"
		[ngClass]="{ 'error': isError || (!formRef?.get(fieldName).valid && formRef?.get(fieldName).touched),
					 'disabled': (isDisabled ? true : null), 'data-grid-search-input': isSearchField }"
         disabled="{{isDisabled ? true : null}}"
         [value]="_value"
  />

	<esp-icon *ngIf="!value && isSearchField" class="search-icon" name="search" title="{{'icon.search.tooltip'|translate}}"></esp-icon>
	<button *ngIf="value && isSearchField" class="clear-search-icon" type="button"
		[attr.aria-label]="'input.clear.search' | translate"
		title="{{'input.clear.search' | translate}}"
		(click)="onClose(); $event.stopPropagation()">
		<esp-icon name="x"></esp-icon>
	</button>

	<span *ngIf="isSearchField" class="screenreader-only" aria-live="polite" aria-atomic="true">{{ searchClearedAnnouncement || announcement }}</span>

	<label *ngIf="value && showPlaceholderAsLegend">{{placeHolderText}}</label>

	<div *ngIf="hasError" class="help-block error-message-text">
		<ng-content></ng-content>
	</div>
</div>
